import {updateSessionId} from "./session";
import {getPdfReport, getReport} from "../api/data";
import {dispatchError} from "../utils";

const initialState = {
  activeReport: null,
  getTableauReportApiError: null,
  batchReports: [],
  pdfReport: null,
  getBatchReportsApiError: null
}

export const getTableauReport = (endpoint, useCurrentDistrict, reportType=null, reportsDistrict=null) => async (dispatch, getState) => {
  const state = getState();
  
  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData
  }

  if (useCurrentDistrict) {
    queryParams['districtId'] = (reportsDistrict) ? reportsDistrict.externalId : state.districts.currentDistrict.externalId
  }

  if (reportType) {
    queryParams['reportType'] = reportType;
  }

  try {
    const response = await getReport(endpoint, queryParams);

    await dispatch({
      type: 'reports/getTableauReportSuccess',
      payload: response
    });

    await dispatch(updateSessionId(response.loggedInUserSessionId));
  } catch (error) {
    await dispatchError(error, {
      type: 'reports/getTableauReportApiError',
      payload: 'Api Error retrieving report'
    }, dispatch);
  }
}

export const getReportPdf = (fileName) => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData,
    pdfFileName: fileName
  }

  try {
    const response = await getPdfReport(queryParams);

    const pdfReport = new Blob([response], {type: "application/pdf"});

    await dispatch({
      type: 'reports/getPdfReportSuccess',
      payload: pdfReport
    });
  } catch (error) {
    await dispatchError(error, {
      type: 'reports/getPdfReportApiError',
      payload: 'Api Error retrieving PDF report'
    }, dispatch);
  }
}

export const getBatchReports = () => async (dispatch, getState) => {
  const state = getState();

  const queryParams = {
    loggedInUserName: state.session.currentUser.username,
    sessionId: state.session.sessionData,
    districtId: state.districts.currentDistrict.id
  }

  try {
    const response = await getReport('getBatchReports', queryParams, true);

    await dispatch({
      type: 'reports/getBatchReportsSuccess',
      payload: response
    });

    if (response) {
      await dispatch(updateSessionId(response[0].loggedInUserSessionId));
    }
  } catch (error) {
    dispatch({
      type: 'reports/getBatchReportsApiError',
      payload: 'Api Error retrieving batch reports'
    });
  }
}

export const clearActiveReport = () => {
  return {
    type: 'reports/clearActiveReport'
  };
}

export const clearBatchReports = () => {
  return {
    type: 'reports/clearBatchReports'
  }
}

export const clearBatchReportAlerts = () => {
  return {
    type: 'reports/clearBatchReportsAlerts'
  }
}

export default function reportsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case 'reports/getTableauReportSuccess':
      return {
        ...state,
        activeReport: payload,
        getTableauReportApiError: null
      }
    case 'reports/getTableauReportApiError':
      return {
        ...state,
        activeReport: null,
        getTableauReportApiError: payload
      }
    case 'reports/getPdfReportSuccess':
      return {
        ...state,
        pdfReport: payload,
        getPdfReportApiError: null
      }
    case 'reports/getPdfReportApiError':
      return {
        ...state,
        pdfReport: null,
        getPdfReportApiError: payload
      }

    case 'reports/getBatchReportsSuccess':
      return {
        ...state,
        batchReports: payload,
        getBatchReportsApiError: null
      }
    case 'reports/getBatchReportsApiError':
      return {
        ...state,
        batchReports: [],
        getBatchReportsApiError: payload
      }
    case 'reports/clearActiveReport':
      return {
        ...state,
        activeReport: null,
        getTableauReportApiError: null,
        pdfReport: null,
        getPdfReportApiError: null
      }
    case 'reports/clearBatchReports':
      return {
        ...state,
        batchReports: [],
        getBatchReportsApiError: null
      }
    case 'reports/clearBatchReportsAlerts':
      return {
        ...state,
        getBatchReportsApiError: null
      }
    default:
      return {
        ...state
      };
  }
}